<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Job Status</h4>
  </div>

  <div class="card-body mt-2">
    <form @submit.prevent="storeContact(employmentJobStatus)">
      <div class="row">
        <div class="col-sm-6 offset-md-3 col-12">
          <div class="row"  v-for="(des, index) in employmentJobStatus">
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Job Status</label>
                <v-select
                    placeholder="Select Job Status"
                    v-model="des.job_status"
                    :options="jobStatusList"
                    label="name"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Effective Date</label>
                <input type="date" id="full-name" required class="form-control" v-model="des.employment_job_status_effective_date"
                       placeholder="Effective Date" />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Remarks</label>
                <input type="text" id="full-name" class="form-control" v-model="des.employment_job_status_remarks"
                       placeholder="Remarks" />
              </div>
            </div>

            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body mt-2">
    <div class="card p-2" style="min-height: 200px">
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>Sl No.</th>
            <th>Effective Date</th>
            <th>Job Status</th>
            <th>Remarks</th>
            <th>Updated Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in logList" :key="i">
            <td>{{ i+1 }}</td>
            <td>{{ item.employment_job_status_effective_date }}</td>
            <td>{{ item.employment_job_status_name }}</td>
            <td>{{ item.employment_job_status_remarks }}</td>
            <td>{{ item.update_date }}</td>
          </tr>
          </tbody>
        </table>
        <p v-if="logList.length < 0" class="text-center mt-5">No data</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleHospital from '@/services/modules/hospital'
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll'

const emit = defineEmits(['storeContact'])
const props = defineProps({
  items: {
    type: Array
  }
})

const route = useRoute()
const { fetchNoteMasterList } = handleHospital()
const { fetchContactItemLogs } = handleHrPayroll()

let jobStatusList = ref([])
let logList = ref([])

const employmentJobStatus  = ref([
    {
      job_status: '',
      employment_job_status_effective_date:'',
      employment_job_status_remarks:'',
    }
])

const storeContact = (data) => {
  let items = data.map(item => ({
    employment_job_status: parseInt(item.job_status.id),
    employment_job_status_name: item.job_status.name,
    employment_job_status_effective_date: item.employment_job_status_effective_date,
    employment_job_status_remarks: item.employment_job_status_remarks,
  }));

  emit('storeContact', {'items':items})
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const getLogList = async () => {
  let query = getQuery()
  query += `&contact_profile_id=${route.query.contactId}&field=employment_job_status`
  logList.value = []

  await fetchContactItemLogs(query).then(res => {
    if (!res.status){
      logList.value = []
      return
    }
    logList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getJobStatusList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=job_status'

  jobStatusList.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      jobStatusList.value = []
      return
    }
    jobStatusList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const reset = () => {
  employmentJobStatus.value.length = 0;
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});

const formDataSet = () => {
    if (props.items.length){
      employmentJobStatus.value = props.items.map(item => ({
        ...item,
        job_status:{
          id: parseInt(item.employment_job_status),
          name: item.employment_job_status_name
        },
        employment_job_status_effective_date: item.employment_job_status_effective_date,
        employment_job_status_remarks: item.employment_job_status_remarks,
      }));
    }
}

onMounted(() => {
  Promise.all([
    getJobStatusList(),
    getLogList()
  ])
})

</script>
